import request from '../helpers/request';

const addAttachmentsToRequestComment = async (commentId, body) => {
  return await request.post(
    `/Request/request_note_attachment/${commentId}`,
    body,
    `Произошла ошибка при загрузке файлов`
  );
};

export default addAttachmentsToRequestComment;
